import React, { useContext } from "react";
import PropTypes from "prop-types";
import { PhoneNumberContainer } from "./style";
import { ThemeContext } from "helpers/contexts";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import * as Constant from "constant";

PhoneNumberInput.propTypes = {
  onPhoneNumberChange: PropTypes.func,
  onCountryChange: PropTypes.func,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf([
    Constant.SIZE.small,
    Constant.SIZE.medium,
    Constant.SIZE.large,
    Constant.SIZE.xl,
  ]),
};

PhoneNumberInput.defaultProps = {
  placeholder: "",
};

function PhoneNumberInput(props) {
  const theme = useContext(ThemeContext);
  let fontSize, padding;

  switch (props.size) {
    case Constant.SIZE.small:
      fontSize = FONT_SIZE.small;
      padding = "0px";
      break;
    case Constant.SIZE.medium:
      fontSize = FONT_SIZE.medium;
      padding = "7px 0";
      break;
    case Constant.SIZE.large:
      fontSize = FONT_SIZE.large;
      padding = "7px 11px";
      break;
    case Constant.SIZE.xl:
      fontSize = FONT_SIZE.xl;
      padding = "9px 13px";
      break;
    default:
      fontSize = FONT_SIZE.small;
      padding = "0px";
      break;
  }

  const handleInputChange = (value, country) => {
    props.onPhoneNumberChange && props.onPhoneNumberChange(value, country);
  };

  return (
    <PhoneNumberContainer
      inputTextColor={theme.colors.gray.charcoal}
      arrowColor={theme.colors.gray.gray600}
      optionBorderColor={theme.colors.gray.gray200}
      fontSize={fontSize}
      padding={padding}
    >
      <PhoneInput
        placeholder={props.placeholder}
        countryCallingCodeEditable={false}
        country={DEFAULT_COUNTRY}
        onChange={handleInputChange}
        value={props.value}
        enableLongNumbers
        countryCodeEditable={false}
      />
    </PhoneNumberContainer>
  );
}

const DEFAULT_COUNTRY = "il";

const FONT_SIZE = { small: "12px", medium: "14px", large: "16px", xl: "18px" };

export default PhoneNumberInput;
